import * as Sentry from '@sentry/browser';

/*
  Ошибки фронта уходят в GlitchTip — он принимает события по протоколу
  Sentry, поэтому используется Sentry SDK. DSN клиентский и публичный по
  своей природе (виден в бандле), ключей и токенов для него не нужно.
*/
const GLITCHTIP_DSN =
  'https://669fc292f456492cbbd46cc599323a10@sentry.pravo.digitalburo.ru/3';

export default defineNuxtPlugin((nuxtApp) => {
  /* Локальная разработка в GlitchTip не шлёт. */
  if (import.meta.dev) return;

  const { ENVIRONMENT } = useRuntimeConfig().public;

  Sentry.init({
    dsn: GLITCHTIP_DSN,
    environment: ENVIRONMENT || 'production',
    /* 1% транзакций (загрузки страниц и переходы). */
    tracesSampleRate: 0.01,
    integrations: (defaults) => [
      /* GlitchTip не поддерживает сессии. */
      ...defaults.filter(
        (integration) => integration.name !== 'BrowserSession',
      ),
      Sentry.browserTracingIntegration(),
    ],
  });

  /*
    Ошибки в компонентах и хуках Nuxt перехватывает сам и до глобальных
    обработчиков SDK они не доходят — отправляем их явно.
  */
  nuxtApp.hook('vue:error', (error) => {
    Sentry.captureException(error);
  });

  nuxtApp.hook('app:error', (error) => {
    Sentry.captureException(error);
  });
});
